import { useEffect, useState } from "react";
import Api from "../openapi";
import { MealBriefResponse } from "../openapi/client";

export default function useMeals() {
  const [mealList, setMealList] = useState<MealBriefResponse[]>([]);

  useEffect(() => {
    const getMeals = async () => {
      try {
        const res = await Api.AdminMeal.listBriefMeals();
        setMealList(res.data);
      } catch (error) {}
    };
    getMeals();
  }, []);
  return mealList;
}
